import { ListItem, Text } from '@chakra-ui/react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import { flattenText } from '../../functions/utils';

export function GameText({ text, components: comps, className, ...rest }) {
  // ReactMarkdown automatically wraps text in <p></p>
  var components = comps || {
    p: props => <Text {...rest}>{props.children}</Text>,
    li: props => <ListItem {...rest}>{props.children}</ListItem>,
    move: props => <span className="move-ref">{props.children}</span>,
    trigger: props => <span className="trigger-text">{props.children}</span>,
    stat: props => <span className="roll-stat">{props.children}</span>,
    'list-heading': props => (
      <Text className="list-header" {...rest}>
        {props.children}
      </Text>
    ),
    indent: props => (
      <>
        <span className="indent" />
        {props.children}
      </>
    ),
  };

  text = flattenText(text);

  return (
    <ReactMarkdown
      className="game-text"
      rehypePlugins={[rehypeRaw]}
      children={text}
      components={components}
      {...rest}
    />
  );
}

GameText.defaultProps = {
  fontSize: 'sm',
};
